import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LanguageService } from '@pyg-services/language/language.service';
import { TranslatePipe } from '@ngx-translate/core';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.scss'],
  imports: [TranslatePipe, LangRouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinksComponent {
  private readonly lang = inject(LanguageService);

  public readonly tel = this.lang.langTelNum;
  public readonly email = this.lang.langEmail;
}
